import $ from 'jquery';

import application from 'application/application';

application.directive('ngValidate', [
	'$timeout',
	'validationFeedbacks',
	($timeout, validationFeedbacks) => ({
		restrict: 'A',
		link(scope, element, attributes) {
			var form = scope[attributes.name];

			scope.$resetFormValidation = formName => {
				return () => {
					$('input,textarea,select')
						.filter(
							(index, input) => input.form && input.form.name === formName
						)

						.removeClass('is-invalid is-valid');
				};
			};

			$timeout(() => {
				function isSelect2Element(element) {
					return element.attr('custom-select');
				}

				element

					.on('input change click', event => {
						let control = form[event.target.name];

						if (
							(/^(?:input|textarea)$/i.test(event.target.tagName) &&
								/(?:input|keyup)$/i.test(event.type)) ||
							(/^(?:radio|checkbox)$/i.test(event.target.type) &&
								event.type === 'click') ||
							(event.target.tagName === 'SELECT' && event.type === 'change') ||
							(control != undefined &&
								control.$$attr.id == 'createEventInputTaskDate' &&
								event.type === 'change') ||
							(control != undefined &&
								control.$$attr.id == 'inputTaskDate' &&
								event.type === 'change') ||
							(control != undefined &&
								control.$$attr.id == 'createIncomeDate' &&
								event.type === 'change') ||
							(control != undefined &&
								control.$$attr.id == 'createExpenseDate' &&
								event.type === 'change')
						) {
							if (typeof control === 'object') {
								let input = $(`[name="${control.$name}"]`).filter(
									(index, input) =>
										input.form && input.form.name === attributes.name
								);

								input

									.removeClass(control.$valid ? 'is-invalid' : 'is-valid')

									.addClass(control.$valid ? 'is-valid' : 'is-invalid')

									.attr('aria-invalid', control.$invalid);

								const isSelect2El = isSelect2Element(input);
								let feedback = control.$$attr.customFeedbackError || '';

								const customInvalidFeedback =
									control.$$attr.customInvalidFeedback;

								if (!customInvalidFeedback) {
									if (isSelect2El && !input.next().next('.invalid-feedback')[0])
										input
											.next()
											.after($('<div />').addClass('invalid-feedback'));
									else if (!isSelect2El && !input.next('.invalid-feedback')[0])
										input.after($('<div />').addClass('invalid-feedback'));
								}

								if (Array.isArray(validationFeedbacks.invalid)) {
									let match =
										validationFeedbacks.invalid.find(
											value => control.$error[value.type]
										) || {};

									if (match.feedback) feedback = match.feedback;
								}

								if (customInvalidFeedback) {
									$(`.${customInvalidFeedback}`)
										.addClass(
											control.$valid ? 'valid-feedback' : 'invalid-feedback'
										)
										.text(control.$valid ? '' : feedback);
								} else {
									if (isSelect2El)
										input
											.next()
											.next('.invalid-feedback')
											.text(feedback);
									else input.next('.invalid-feedback').text(feedback);
								}
							}
						}
					})

					.on('submit', event => {
						event.preventDefault();

						let firstInvalidInput = null;

						form.$$controls.forEach(control => {
							let input = $(`[name="${control.$name}"]`).filter(
								(index, input) =>
									input.form && input.form.name === attributes.name
							);

							// Captura o primeiro input inválido
							if (!firstInvalidInput && control.$invalid) {
								firstInvalidInput = input[0];
							}

							input
								.removeClass(control.$valid ? 'is-invalid' : 'is-valid')
								.addClass(control.$valid ? 'is-valid' : 'is-invalid')
								.attr('aria-invalid', control.$invalid);

							const isSelect2El = isSelect2Element(input);
							let feedback = control.$$attr.customFeedbackError || '';

							const customInvalidFeedback =
								control.$$attr.customInvalidFeedback;

							if (!customInvalidFeedback) {
								if (isSelect2El && !input.next().next('.invalid-feedback')[0])
									input.next().after($('<div />').addClass('invalid-feedback'));
								else if (!isSelect2El && !input.next('.invalid-feedback')[0])
									input.after($('<div />').addClass('invalid-feedback'));
							}

							if (Array.isArray(validationFeedbacks.invalid)) {
								let match =
									validationFeedbacks.invalid.find(
										value => control.$error[value.type]
									) || {};

								if (match.feedback) feedback = match.feedback;
							}

							if (customInvalidFeedback) {
								$(`.${customInvalidFeedback}`)
									.addClass(
										control.$valid ? 'valid-feedback' : 'invalid-feedback'
									)
									.text(control.$valid ? '' : feedback);
							} else {
								if (isSelect2El)
									input
										.next()
										.next('.invalid-feedback')
										.text(feedback);
								else input.next('.invalid-feedback').text(feedback);
							}
						});

						// Coloca o foco no primeiro input inválido
						if (firstInvalidInput) {
							firstInvalidInput.focus();
						}
					});
			});
		}
	})
]);
